import { createFileRoute } from '@tanstack/react-router';
import { AlertTokenAction } from '@/components/alerts/AlertTokenAction';

export const Route = createFileRoute('/alerte/confirma')({
  validateSearch: (s: Record<string, unknown>) => ({ token: typeof s.token === 'string' ? s.token : '' }),
  head: () => ({
    meta: [
      { title: 'Confirmă alerta de căutare | RO Auto Market' },
      { name: 'description', content: 'Confirmă alerta de căutare RO Auto Market ca să primești emailuri cu mașini noi.' },
      { name: 'robots', content: 'noindex, nofollow' },
      { property: 'og:title', content: 'Confirmă alerta de căutare | RO Auto Market' },
      { property: 'og:description', content: 'Confirmarea alertei de căutare RO Auto Market.' },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary' },
    ],
  }),
  component: () => <AlertTokenAction mode="confirm" token={Route.useSearch().token} />,
});
